// libs
import { styled } from '@nykaa/ui-components';

//components
import FilterRadioBase from 'shared/components/Filter/components/FilterRadio';

//mixin
import { fadeIn } from 'shared/styles/animations/fadeIn';

//styles
import { BREAKPOINTS, MWEB_HEADER_ZINDEX } from 'shared/styles/base';

export const Container = styled.div`
  position: relative;
  width: 100%;
  z-index: ${MWEB_HEADER_ZINDEX - 1};
`;

export const SortButton = styled.button<{ showOptions: boolean; }>`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  width: 100%;
  ${({ theme }) => theme.typography.bodyMedium};

  ${({ theme }) =>
    `background-color: ${theme.colors.surface};
    padding: ${theme.spacing.spacing40} ${theme.spacing.spacing80};
    border-radius: ${theme.borders.buttonBorderRadius};
    border: 1px solid ${theme.colors.textOutline};
  `};

  ${({ showOptions, theme }) =>
    showOptions &&
    `border: 1px solid ${theme.colors.secondary};
    color: ${theme.colors.secondary};
    background-color: ${theme.colors.filterSelected};
  `};
  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    border-radius: ${({ theme }) => theme.borders.mwebButtonBorderRadius};
  }
  &:hover{
    background-color: none;
  }
`;

export const Arrow = styled.div<{ reverseArrow: boolean; }>`
  display: inline-flex;
  ${({ reverseArrow }) =>
    reverseArrow &&
    `transform: rotate(180deg);
     transition: transform 0.2s ease 0s;
    `};
`;

export const Text = styled.div<{ showOptions: boolean; }>`
  ${({ theme }) =>
    `padding-left: ${theme.spacing.spacing40};
     color: ${theme.colors.textSecondary};
  `};
  ${({ showOptions, theme }) => showOptions && `color: ${theme.colors.secondary};`};
  width: max-content;
`;

export const SelectedValue = styled.div<{ showOptions: boolean; }>`
  ${({ theme }) => theme.typography.titleXSmall};
  ${({ theme }) =>
    `padding-left: ${theme.spacing.spacing20};
     padding-right: ${theme.spacing.spacing60};
     color: ${theme.colors.textPrimary};
  `};
  width: max-content;
  ${({ showOptions, theme }) => showOptions && `color: ${theme.colors.secondary};`};
`;

export const PopUp = styled.div`
  position: absolute;
  width: 100%;
  right: 0;

  ${({ theme }) =>
    `background-color: ${theme.colors.filterSurface};
    border-radius: ${theme.borders.radius10};
    box-shadow: ${theme.elevations.shadow100};
    backdrop-filter: blur(${theme.colors.filterBackdropFilter}px);
  `};

  ${fadeIn};
`;

export const FilterRadio = styled(FilterRadioBase)`
  padding: ${({ theme }) => `${theme.spacing.spacing80}`};
`;

export const Wrapper = styled.div`
  display: flex;
`;
